import { toast } from "react-toastify";
import api from "../services/api";

export const saveCustomFieldValue = async (newCustomFieldsValues, entityId) => {
    const bodyCustomFields = newCustomFieldsValues?.map(field => {
        return {
            ...field,
            entityId: field.entityId === 0 && entityId ? entityId : field.entityId,
            values: field?.values?.length > 0 ? field.values : [""],
        }
    })

    try {
        const result = await api.post('api/v2/CustomFieldValue', bodyCustomFields);
        if (result?.data?.success && result?.data?.code === 200) {
            console.log('Custom fields saved');
            localStorage.removeItem('@bendito:cartCustomFieldsFirstStep')
            localStorage.removeItem('@bendito:cartCustomFieldsLastStep')
        } else {
            toast.error('Falha ao salvar campos customizados.');
        };
    } catch (error) {
        console.log('error', error);
        toast.error('Catch: Erro ao salvar campos customizados.');
    }
}